import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { formatAuthor } from '../../composants/utils/utils';
import axiosInstance from '../../configurations/axiosInstance/AxiosInstance';
import { ColorsContext } from '../../composants/colorContext';

const Navbar = () => {
  
  const {colors} = useContext(ColorsContext);
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [articleSubMenu, setArticleSubMenu] = useState([]);
  const handleMouseEnter = (index) => {
    setOpenDropdown(index);
  };
  useEffect(() => {
    let menusString = localStorage.getItem('menus');
    if(menusString){
      if(JSON.parse(menusString).subMenus.length == 0){
        setArticleSubMenu([]);
      }else{
        let menusJson  = JSON.parse(menusString).subMenus;
        menusJson.sort((a, b) => a.name.localeCompare(b.name));
        console.log("menusJson", menusJson);
        setArticleSubMenu(menusJson);
      }
    }else{
      axiosInstance().get('/public/api/menu/WEB_SITE')
      .then(response => {
        
        console.log("response.data", response.data);
        localStorage.setItem('menus', JSON.stringify(response.data)); 
        let menusJson  = response.data.subMenus;
        menusJson.sort((a, b) => a.name.localeCompare(b.name));
        setArticleSubMenu(menusJson);
      })
      .catch(error => { console.error('There was an error!', error); });
    }
  }, []);

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  return (
    <nav style={{backgroundColor: colors.COLOR_NAVBAR}} className="fixed top-0 left-0 w-full z-50 border-gray-200 py-0 dark:bg-gray-900 shadow-md">
        <div className="flex flex-wrap items-center justify-between max-w-screen-xl px-2 mx-auto">
          <a className="flex items-center">
            <img src="/images/logo/logo.png" width={50} height={50} className="h-6 mr-3 sm:h-9" alt="YouthFP" />
          </a>
          <div className="flex items-center lg:order-2">
            <NavLink to="https://www.unfpa.org/fr" target='_blank' className="flex items-center">
              <img src="/images/logo/unfpa.png" width={50} height={50}  className="h-6 mr-3 sm:h-9" alt="YouthFP" />
            </NavLink>
            <button
                className="block p-2 ml-2 text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:ring-2 focus:ring-gray-200"
                onClick={() => setIsOpen(!isOpen)}
            >
              <span className="sr-only">menu</span>
              <FontAwesomeIcon icon={faBars} />{}
            </button>
          </div>
          <div style={{backgroundColor: colors.COLOR_NAVBAR}} className={`${isOpen ? "block" : "hidden"} lg:flex lg:items-center lg:w-auto w-full lg:bg-transparent`}>
            <ul className="flex flex-col lg:flex-row lg:space-x-8">
              <li>
                <a href="/" className="block py-2 px-2 text-gray-700 hover:text-purple-700">Acceuil</a>
              </li>
              {
                articleSubMenu.length == 0 ? (<></>) :<li className="relative" onMouseEnter={() => handleMouseEnter(1)}  onMouseLeave={handleMouseLeave}>
                  <button className="block py-2 px-2 text-gray-700 hover:text-purple-700 flex items-center">
                  Nos Articles
                    <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M5 7l5 5 5-5" />
                    </svg>
                  </button>
                  {openDropdown === 1 && (
                      <ul style={{backgroundColor: colors.COLOR_NAVBAR}} className="absolute left-0 top-full mt-0 w-48 border rounded-md shadow-lg z-25">
                        {

                          (articleSubMenu.length != 0 )&& articleSubMenu.map(menu =>{
                            return <li title={menu.description} key={menu.name}><a style={{textDecoration: 'none'}} href={`/articles/${menu.id}`} className="block px-0 py-2 hover:bg-gray-100">{formatAuthor(menu.description, 10)}</a></li>
                          })
                        }
                      </ul>
                  )}
                </li>
              }
              
              <li title="Services des Unité de Santé de Reproduction des Ados Jeunes">
                <a href="/service" className="block py-2 px-2 text-gray-700 hover:text-purple-700">Services</a>
              </li>
              <li title="Localisation des Unité de Santé de Reproduction des Ados Jeunes">
                <a href="/usraj/location" className="block py-2 px-2 text-gray-700 hover:text-purple-700">Localisation des USRAJ</a>
              </li>
              <li title="Gallerie">
                <a href="/gallery" className="block py-2 px-2 text-gray-700 hover:text-purple-700">Galerie</a>
              </li>

              <li title="Propos">
                <a href='/about' className="block py-2 px-2 text-gray-700 hover:text-purple-700">A Propos</a>
              </li>

              <li title="Partenaires">
                <a href='/partenaires' className="block py-2 px-2 text-gray-700 hover:text-purple-700">Partenaires</a>
              </li>
              <li title="e-Learning">
                <a target="_blank" href='https://e-learning.youthfp.cm' className="block py-2 px-2 text-gray-700 hover:text-purple-700">e-Learning</a>
              </li>


              
            </ul>
          </div>
        </div>
      </nav>
  );
};

export default Navbar;
